import { useEffect, useState } from "react";
import { useAppContext } from "../functions/Context";

const useTitle = (defaultTitle = "") => {
  const { ui } = useAppContext();
  const [title, setTitle] = useState(defaultTitle);

  useEffect(() => {
    document.title = title;
    ui.setTitle(title);

    return () => {
      document.title = "";
      ui.setTitle("");
    };
  }, [title, ui]);

  return [title, setTitle] as const;
};

export default useTitle;
